import { deserialize, identifier, list, object, serializable } from "serializr";
import { IJsonObject } from "../api";
import { ProjectTaskChecklistItem } from "./ProjectTaskChecklistItem";

interface IProps {
	id?: number | null;
	name?: string;
	items?: ProjectTaskChecklistItem[];
}

export class ProjectTaskChecklist {
	public static fromJson(json: IJsonObject): ProjectTaskChecklist {
		return deserialize(ProjectTaskChecklist, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectTaskChecklist[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public name: string | null;

	@serializable(list(object(ProjectTaskChecklistItem)))
	public items: ProjectTaskChecklistItem[];

	constructor({ id = null, name = "", items = [] }: IProps = {}) {
		this.id = id;
		this.name = name;
		this.items = items;
	}
}
